interface Stat {
  icon: string;
  label: string;
  value: string;
  sub: string;
  color: string;
  bg: string;
}

const stats: Stat[] = [
  { icon: "ri-price-tag-3-line", label: "Total Products", value: "6", sub: "4 active · 1 pending · 1 paused", color: "text-amber-600", bg: "bg-amber-50" },
  { icon: "ri-shopping-bag-3-line", label: "Total Orders", value: "247", sub: "+18 this week", color: "text-emerald-600", bg: "bg-emerald-50" },
  { icon: "ri-money-dollar-circle-line", label: "Revenue (USD)", value: "$41,140", sub: "+$6,200 this month", color: "text-amber-600", bg: "bg-amber-50" },
  { icon: "ri-truck-line", label: "Dropship Partners", value: "4", sub: "3 active · 1 pending", color: "text-emerald-600", bg: "bg-emerald-50" },
  { icon: "ri-eye-line", label: "Product Views", value: "10,946", sub: "+842 this week", color: "text-amber-600", bg: "bg-amber-50" },
  { icon: "ri-star-line", label: "Factory Rating", value: "4.9 / 5", sub: "Based on 247 orders", color: "text-amber-600", bg: "bg-amber-50" },
];

const StatsBar = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
    {stats.map((s) => (
      <div key={s.label} className="bg-white border border-amber-100 rounded-2xl p-4">
        <div className={`w-9 h-9 flex items-center justify-center ${s.bg} rounded-xl mb-3`}>
          <i className={`${s.icon} ${s.color} text-base`}></i>
        </div>
        <div className="font-black text-gray-900 text-xl leading-none mb-1">{s.value}</div>
        <div className="text-gray-500 text-xs font-medium mb-0.5">{s.label}</div>
        <div className="text-gray-400 text-xs">{s.sub}</div>
      </div>
    ))}
  </div>
);

export default StatsBar;
